import React, { FC, useState } from 'react'
import { useDispatch } from 'react-redux'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { Spinner } from 'transfix-ui/components/Spinner/Spinner'
import { useMarketplaceContext } from 'utils/context/MarketplaceContext'
import { LOAD_STATE, LOAD_TABS } from 'apps/fleet-planner/constants'
import { IFile, ILoad } from 'apps/fleet-planner/types'
import { updateLoadStatus } from 'apps/fleet-planner/utils/actions/loadDetails'
import { UploadInputLink } from '../atoms/UploadInputLink'
import PodRejectionBanner from './PodRejectionBanner'

interface IUploadPodAlertProps {
  load: ILoad
  onUpload: (newTab: LOAD_TABS) => void
}

export const UploadPodAlert: FC<IUploadPodAlertProps> = ({ load, onUpload }) => {
  const dispatch = useDispatch()
  const { status, pods = [] } = load || {}
  const isStatusDelivered = status === LOAD_STATE.Delivered
  const { addAttachments, shipmentDetails } = useMarketplaceContext()

  const { documents: mpDocuments = [] } = shipmentDetails || {}
  const rejectedDocuments = mpDocuments.filter(({ key }) => key === 'pod_rejected')
  const [recentRejectedDocuments] = rejectedDocuments || []
  const [loading, setLoading] = useState<boolean>(false)
  const { podRemovalReason } = recentRejectedDocuments || {}

  const changeHandler = async (newFiles: IFile[]) => {
    setLoading(true)
    onUpload(LOAD_TABS.documents)

    const response = await addAttachments(load, newFiles, 'pod')
    const { id: loadId } = response || {}
    if (loadId && isStatusDelivered) {
      dispatch(updateLoadStatus(load, LOAD_STATE['Payment Pending'], undefined))
    }
    setLoading(false)
  }

  const UploadPodMessage = () => (
    <InlineMessage
      message={
        <p>
          <strong>Please upload a POD. </strong>
          <span>We need a POD to start processing your payment. </span>
          <UploadInputLink label='Upload POD' onUpload={changeHandler} />
        </p>
      }
      type={INLINE_MESSAGE_VARIANTS.ALERT}
    />
  )

  const PodRejectionMessage = () => <PodRejectionBanner podRemovalReason={podRemovalReason} />

  const showUploadMessage = isStatusDelivered && !pods.length && !podRemovalReason
  const showRejectionMessage = !!podRemovalReason
  return (
    <div className='mt2'>
      {loading && <Spinner />}
      {showUploadMessage && <UploadPodMessage />}
      {showRejectionMessage && <PodRejectionMessage />}
    </div>
  )
}
